import { Tabs } from '@highlight/ui'
import type { MeetingTab } from '../meeting-tabs'

const TAB_LABELS: Record<MeetingTab, string> = {
  brief: 'Brief',
  notepad: 'Notes',
  transcript: 'Transcript',
  recap: 'Recap',
  chat: 'Chat',
}

interface MeetingViewUnderlinedTabBarProps {
  tabs: ReadonlyArray<MeetingTab>
}

/** The `tabs` layout's bar: the Meeting View's tabs as underlined text. The panels it drives live in `body.tsx`. */
export function MeetingViewUnderlinedTabBar({ tabs }: MeetingViewUnderlinedTabBarProps) {
  return (
    <Tabs.List
      aria-label="Meeting"
      data-tour-section="meeting-tabs"
      className="flex h-9 gap-4 rounded-none border-b bg-transparent p-0 px-5"
      // Sits on the list's hairline, 1px down so it covers it rather than stacking above it
      indicatorClassName="border-marker bottom-[-1px] top-auto h-0 rounded-none border-b-2 bg-transparent shadow-none dark:bg-transparent"
    >
      {tabs.map((tab) => (
        <Tabs.Tab key={tab} value={tab} className="rounded-none px-0">
          {TAB_LABELS[tab]}
        </Tabs.Tab>
      ))}
    </Tabs.List>
  )
}
